<template>
  <div>
    <acheader></acheader>
    <div class="row mainbody">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <poolsidebar></poolsidebar>
      </div>
      <div class="col-lg-10 col-md-8 col-sm-12">
        <div class="moduleWrapper">
          <div class="moduleCard">
            <div class="row mb-2">
               <div class="col-12 text-right">
                 <a href="javascript:void(0)" @click="goBack"><font-awesome-icon icon="arrow-left" role="presentation"></font-awesome-icon>Go Back</a>
               </div>
            </div>
            <h2 class="mb-4">{{bundlename}} Bundle Members</h2>
            <div v-if="bundleusers!==null">
              <div class="row mt-2" v-if="bundleusers.length>0" v-for="user in bundleusers">
                <div class="col-4" v-html="user.CName"></div>
                <div class="col-2">
                  <button class="btn btn-secondary btn-medium smallheight nopadding" @click="openAvailability(user.ClientID)">Manage Availability</button>
                </div>
                <div class="col-6">
                  <button class="btn btn-secondary btn-short smallheight nopadding" @click="unassignMember(user.ClientID)">Unassign</button>
                </div>
              </div>
              <div class="row" v-if="bundleusers.length===0">
                <div class="col-12">
                  This bundle does not have any members
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal title="Manage Bundle Product Availability" ref="mdlAvail" size="xl" scrollable @ok="doAvailabilityChange">
        <div class="row" v-if="bundlename!==null">
           <div class="col-12">
                <p>Manage available products for {{bundlename}}</p>
                <p>
                  <b>Checked</b> = will be able to see the product and use it.<br />
                  <b>Unchecked</b> = will not be able to see the product or use it.
                </p>
           </div>
        </div>
        <div class="row mt-2" v-if="bundleuserproducts!==null" v-for="bup in bundleuserproducts">
           <div class="col-1">
              <input type="checkbox" v-model="bup.IsEnabled" />
           </div>
           <div class="col-11">
              {{bup.ProductName}}
           </div>
        </div>
    </b-modal>
    <acfooter></acfooter>
  </div>

</template>

<script>
   import "core-js/stable";
   import "regenerator-runtime/runtime";
   import acheader from "../../layout/Header.vue"
   import acfooter from "../../layout/Footer.vue"
   import poolsidebar from "../../layout/Pool/Sidebar.vue"

   export default {
    name: "BundleUsers",
    components: {acheader,acfooter,poolsidebar},
    data() {
      return {
         bundlename:null,
         bundleproducts:null,
         bundleusers:null,
         bundleuserproducts:null
      }
    },
    methods: {
      doAvailabilityChange() {
        var cmds=[];

        for(var bup of this.bundleuserproducts) {
          cmds.push({
            Operation: "LicensePool",
            Function: "ToggleBundleProduct",
            Fields: {
              LicensePoolID: this.sdata.activepool.LicensePoolID,
              BundleID: this.$route.params.id,
              BundleProductID: bup.BundleProductID,
              OnOff: bup.IsEnabled?"true":"false",
              ClientID: bup.ClientID
            }
          });
        }
        
        this.apiCommand(cmds).then(r=>{
          this.popDialog(0, "Availability Changes Successful");
        })
      },
      goBack() {
        this.$router.back();
      },
      openAvailability(clientID) {
        this.apiCommand([
          {
            Operation: "LicensePool",
            Function: "GetClientBundleStatus",
            Fields: {
              LicensePoolID: this.sdata.activepool.LicensePoolID,
              BundleID: this.$route.params.id,
              ClientID: clientID
            }
          }
        ]).then(r=>{
          var cr=JSON.parse(r.CommandResult);
          var stat = JSON.parse(cr.returnObjects[0].returnObject);
          var bpu=[];

          for(var cp of stat) {
            var cpus = {
              IsEnabled: cp.IsEnabled,
              BundleProductID: cp.BundleProductID,
              ClientID: cp.ClientID
            }
            var pr=this.bundleproducts.filter(p=>p.BundleProductID===cp.BundleProductID);
            if (pr.length>0) {
              cpus.ProductName=pr[0].ProductName;
            }
            bpu.push(cpus);
          }

          this.bundleuserproducts=bpu;
          this.$refs["mdlAvail"].show();
        })
      },
      render() {
        this.apiCommand([
         {
           Operation: "LicensePool",
           Function: "GetBundleUsers",
           Fields: {
             LicensePoolID: this.sdata.activepool.LicensePoolID,
             BundleID: this.$route.params.id
           }
         },
         {
           Operation: "LicensePool",
           Function: "GetBundleAndProducts",
           Fields: {
             LicensePoolID: this.sdata.activepool.LicensePoolID,
             BundleID: this.$route.params.id
           }
         }
        ]).then(r=>{
          var cr = JSON.parse(r.CommandResult);
          var bu=JSON.parse(cr.returnObjects[0].returnObject);
          for(var u of bu) {
            u.CName=this.buildSimUser(u.ClientID, u.Username, u.EmailAddress, u.FirstName, u.LastName, true, true);
          }

          this.bundleusers=bu;

          var bap = cr.returnObjects[1].returnObject.split("||||");
          var b=JSON.parse(bap[0]);
          this.bundleproducts=JSON.parse(bap[1]);
          this.bundlename=b.BundleName;

 
        });
      },
      unassignMember(clientID) {
        this.$bvModal.msgBoxConfirm('Are you sure you wish to unassign this member from the bundle?', {
          title: 'Confirm Unassign',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }).then(value => {
          if (value) {
            this.apiCommand([
              {
                Operation: "Client",
                Function: "UnassignBundle",
                Fields: {
                  BundleID: this.$route.params.id,
                  ClientID: clientID
                }
              }
            ]).then(r=>{
              this.popDialog(0, "Member Unassigned Successfully");
              this.render();
            });
          }
        });
      }
    },
    mounted() {
      this.doPage().then(r=>{
        this.bootstrapPool(this.$route.params.pid);
        this.render();
      });
     }
   }
</script>
